import React from 'react';
import { FadeIn } from './FadeIn';
import { Check } from 'lucide-react';
export function CTASection() {
  return <section id="agenda" className="py-24 px-6 bg-gold text-navy" data-id="element-35">
      <div className="max-w-4xl mx-auto text-center" data-id="element-36">
        <FadeIn data-id="element-37">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8" data-id="element-38">
            Si tu negocio está en este punto, es momento de ordenarlo
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-39">
          <p className="text-xl md:text-2xl font-medium mb-10 max-w-3xl mx-auto" data-id="element-40">
            Si sientes que la operación está desordenada y necesitas claridad
            real sobre qué hacer… Este es el siguiente paso.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-41">
          <div className="flex flex-col md:flex-row justify-center gap-6 md:gap-10 mb-12" data-id="element-42">
            {['Entendemos tu operación', 'Identificamos el caos', 'Te damos claridad estratégica'].map((item, i) => <div key={i} className="flex items-center justify-center gap-3" data-id="element-43">
                <div className="w-6 h-6 rounded-full bg-navy flex items-center justify-center shrink-0" data-id="element-44">
                  <Check className="w-4 h-4 text-gold" data-id="element-45" />
                </div>
                <span className="font-semibold text-lg" data-id="element-46">{item}</span>
              </div>)}
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-47">
          <div className="flex flex-col items-center gap-4" data-id="element-48">
            <a href="https://wa.me/17866035862?text=Hola%20Oscar%2C%20quiero%20agendar%20un%20diagn%C3%B3stico%20estrat%C3%A9gico" target="_blank" rel="noopener noreferrer" className="inline-block bg-navy hover:bg-navy-dark text-white font-bold text-xl px-10 py-5 rounded transition-all duration-300 hover:scale-105 shadow-xl" data-id="element-49">
              Agenda un diagnóstico estratégico
            </a>
            <p className="text-sm font-medium opacity-80 max-w-md mt-2" data-id="element-50">
              Solo para dueños de negocio con operación activa que buscan
              estructura real.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}